import React, { Component } from 'react';
import { Modal, Button } from 'antd';
import { ACTION_STATUS } from '../../../../../utils/ActionStatus';
import PersonalTradeRecognizeGrid from './PersonalTradeRecognizeGrid';

class PersonalTradeRecognizeDialog extends Component {

  refreshButtonOnClicked = () => {
    const personalTradeRequestIdList = this.props.personalTradeRequestRecognizeControlModal.personalTradeRequestIdList;
    this.props.loadPersonalTradeRequestRecognizeResult(personalTradeRequestIdList);
  }

  render() {
    const {
      loadPersonalTradeRequestRecognizeResultActionStatus,
      personalTradeRequestRecognizeControlModal,
    } = this.props;

    const {
      isOpened,
    } = personalTradeRequestRecognizeControlModal;

    const isLoading = loadPersonalTradeRequestRecognizeResultActionStatus === ACTION_STATUS.LOGINING;

    let modalTitle = 'Recognize Personal Trade Request';

    return (
      <div>
        <Modal
          title={modalTitle}
          centered
          width={1300}
          visible={isOpened}
          onOk={() => this.props.resetPersonalTradeRequestRecognizeModalDialog()}
          onCancel={() => this.props.resetPersonalTradeRequestRecognizeModalDialog()}
          cancelButtonProps={{ hidden: true }}
          destroyOnClose={true}
          maskClosable={false}
        >
          <div style={{ marginBottom: 10 }}>
            <Button 
              onClick={this.refreshButtonOnClicked} 
              size='small'
              style={{ fontSize: 10 }}
              loading={isLoading}
              type='primary'>
              Refresh
            </Button>
          </div>

          <div style={{ height: 500 }}>
            <PersonalTradeRecognizeGrid {...this.props} />
          </div>
        </Modal>
      </div>
    );
  }
}

export default PersonalTradeRecognizeDialog;